
export class ComboGrupo {
  Id: number;
  NOMBRE: string;
}

export class ComboCliente {
  Id: number;
  NOMBRE: string;
}

export class ComboSerieDocumental {
  ID: number;
  NOMBRE: string;
}

//🥑🥑
export class ComboProveedor {
  ID: number;
  NOMBRE: string;
}

export class ComboTipoServicio {
  ID: number;
  NOMBRE: string;
}
export class ComboInformesTipos {
  Id: number;
  NOMBRE: string;
  DESCRIPCION: string;
}

export class ComboNgSelect {
  ID: number;
  NOMBRE: string;
}

export class ComboPickListViewData {
  ID: number;
  NOMBRE: string;
  elements: ComboNgSelect[];
}


export class ComboEstado {
  ID: number;
  NOMBRE: string;
  TIPO: string;
  IsFinalize: boolean;
  IsCanceled: boolean;
  IsIncidencia: boolean;

  constructor() { }

  static toModel(json: string): ComboEstado {
    const data = JSON.parse(json);
    const toReturn = new ComboEstado();
    toReturn.ID = data.ID;
    toReturn.NOMBRE = data.NOMBRE;
    toReturn.TIPO = data.TIPO;
    toReturn.IsFinalize = data.IsFinalize;
    toReturn.IsCanceled = data.IsCanceled;
    toReturn.IsIncidencia = data.IsIncidencia;
    return toReturn;
  }
}

export class ComboSituacion {
  Id: number;
  NOMBRE: string;
  constructor() { }
}
